var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"testimony vh-for-mobile",style:({'background-color': _vm.bgColor})},[_c('div',{directives:[{name:"observe-visibility",rawName:"v-observe-visibility",value:({
		callback: _vm.fadeInView,
		intersection: {
			threshold: 0.3
		}
	}),expression:"{\n\t\tcallback: fadeInView,\n\t\tintersection: {\n\t\t\tthreshold: 0.3\n\t\t}\n\t}"}],staticClass:"testimony__wrapper"},[_c('blockquote',[_c('p',{style:({'color': _vm.textColor})},[_vm._v(_vm._s(_vm.text))])]),_c('cite',{style:({'color': _vm.textColor})},[_vm._v(_vm._s(_vm.by))])])])}
var staticRenderFns = []

export { render, staticRenderFns }